import React, { useRef, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Toast } from "primereact/toast";
import AuthService from "../../modules/Admin/services/AuthService";
import NotificationService from "../../modules/Admin/services/NotificationService";
import LeadService from "../../modules/Admin/services/LeadService";
import profilePic from "../../Images/DreamTown.png";
import { Badge } from "primereact/badge";
import axios from "axios";
import {
  FaBuilding,
  FaSignOutAlt,
  FaTrash,
  FaUser,
  FaUserAlt,
} from "react-icons/fa";

function Navbar() {
  const [isLoggedIn, setIsLoggedIn] = useState(AuthService.isAuthenticated());
  const [searchTerm, setSearchTerm] = useState("");
  const [showNotifications, setShowNotifications] = useState(false);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const toast = useRef(null);
  const [currentTime, setCurrentTime] = useState("");
  const [greeting, setGreeting] = useState("");
  const [userId, setUserId] = useState(AuthService.getCurrentUser().UserId);
  const [lastLoginTime, setLastLoginTime] = useState("");
  const [totalCount, setTotalCount] = useState(0);
  const [assignedNotifications, setAssignedNotifications] = useState([]);
  const userRole = AuthService.getLoggedInRoleId();
  const [userImage, setUserImage] = useState("");

  useEffect(() => {
    const currentUser = AuthService.getCurrentUser();
    if (currentUser) {
      setUserId(currentUser.UserId);
    } else {
      console.error("User is not logged in.");
      navigate("/login");
    }
  }, []);

  useEffect(() => {
    async function fetchNotificationsByDate() {
      try {
        const response = await NotificationService.getNotificationsByDateAsync(
          userId
        );
        setAssignedNotifications(response);
        console.log(response);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching notifications:", error);
        setLoading(false);
      }
    }
    fetchNotificationsByDate();
  }, [userId]);

  useEffect(() => {
    async function getUserImageById() {
      try {
        const response = await AuthService.getUserImageById(userId);
        setUserImage(response);
        console.log(response);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching notifications:", error);
        setLoading(false);
      }
    }
    getUserImageById();
  }, [userId]);

  useEffect(() => {
    async function getNotifications() {
      try {
        const response = await NotificationService.getNotificationsByDate(
          userId
        );
        setAssignedNotifications(response);
        setTotalCount(response.totalCount || 0);
        setAssignedNotifications(response.leadAssignedNotifications);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching notifications:", error);
        setLoading(false);
      }
    }
    getNotifications();
  }, [userId]);

  useEffect(() => {
    const updateTimeAndGreeting = () => {
      const date = new Date();
      let hours = date.getHours();
      const minutes = date.getMinutes();
      const seconds = date.getSeconds();
      const ampm = hours >= 12 ? "PM" : "AM";

      if (hours < 12) {
        setGreeting("Good Morning");
      } else if (hours < 18) {
        setGreeting("Good Afternoon");
      } else {
        setGreeting("Good Evening");
      }

      hours = hours % 12;
      hours = hours ? hours : 12;
      const minutesFormatted = minutes < 10 ? "0" + minutes : minutes;
      const secondsFormatted = seconds < 10 ? "0" + seconds : seconds;

      setCurrentTime(
        `${hours}:${minutesFormatted}:${secondsFormatted} ${ampm}`
      );
    };

    updateTimeAndGreeting();
    const intervalId = setInterval(updateTimeAndGreeting, 1000);

    return () => clearInterval(intervalId);
  }, []);

  useEffect(() => {
    const fetchLastLoginTime = async () => {
      try {
        const lastLogin = await AuthService.getLastLoginTime(userId);
        if (lastLogin) {
          const formattedTime = new Date(lastLogin).toLocaleString();
          setLastLoginTime(formattedTime);
        }
      } catch (error) {
        console.error("Error fetching last login time:", error);
      }
    };

    if (userId) {
      fetchLastLoginTime();
    }
  }, [userId]);

  const Role = {
    SUPERADMIN: { roleId: 1, roleName: "SuperAdmin" },
    ADMIN: { roleId: 2, roleName: "Admin" },
    MANAGER: { roleId: 3, roleName: "Manager" },
    EMPLOYEE: { roleId: 4, roleName: "Employee" },
  };

  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("hasShownPopup");
    localStorage.removeItem("refreshToken");
    localStorage.removeItem("lastActivityTime");
    if (toast.current) {
      toast.current.show({
        severity: "success",
        summary: "Logged Out",
        detail: "User Logged Out successfully!!",
        className: "custom-toast-delete",
      });
    }
    delete axios.defaults.headers.common["Authorization"];
    setIsLoggedIn(false);

    setTimeout(() => {
      navigate("/login");
    }, 700);
  };

  const handleAccountClick = () => {
    const userId = AuthService.getCurrentUser().UserId;
    navigate(`/edituser/${userId}`);
  };

  function handleNotificationClick() {
    setShowNotifications(!showNotifications);
  }

  const handleSearch = async () => {
    if (searchTerm.trim() !== "") {
      try {
        const leads = await LeadService.searchLeads(searchTerm);
        navigate(`/search?query=${encodeURIComponent(searchTerm)}`, {
          state: { leads },
        });
      } catch (error) {
        console.error("Error performing search:", error);
        toast.current.show({
          severity: "error",
          summary: "Search Error",
          detail: "An error occurred while searching. Please try again later.",
          life: 3000,
        });
      }
    }
    setSearchTerm("");
  };

  const refreshNotifications = async () => {
    setLoading(true); // Show loader while fetching
    try {
      const response = await NotificationService.getNotificationsByDate(userId);
      setAssignedNotifications(response.leadAssignedNotifications);
      setTotalCount(response.totalCount || 0);
    } catch (error) {
      console.error("Error refreshing notifications:", error);
    } finally {
      setLoading(false); // Hide loader once fetching is done
    }
  };

  function formatTimeElapsed(timestamp) {
    const timeElapsed = Math.floor((new Date() - new Date(timestamp)) / 1000);
    if (timeElapsed < 60) {
      return `${timeElapsed} seconds ago`;
    } else if (timeElapsed < 3600) {
      return `${Math.floor(timeElapsed / 60)} minutes ago`;
    } else if (timeElapsed < 86400) {
      return `${Math.floor(timeElapsed / 3600)} hours ago`;
    } else {
      return `${Math.floor(timeElapsed / 86400)} days ago`;
    }
  }

  return (
    <nav
      class="navbar navbar-main navbar-expand-lg px-0 mx-3 shadow-none border-radius-xl"
      id="navbarBlur"
      data-scroll="true"
    >
      <div class="container-fluid py-1 px-3">
        <nav aria-label="breadcrumb">
          <ol class="breadcrumb bg-transparent mb-0 pb-0 pt-1 px-0 me-sm-6 me-5"></ol>
        </nav>
        <div
          class="collapse navbar-collapse mt-sm-0 mt-2 me-md-0 me-sm-4"
          id="navbar"
        >
          <div class="ms-md-auto pe-md-3 d-flex align-items-center">
            <div class="input-group input-group-outline">
              <input
                className="form-control"
                type="search"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                onKeyPress={(e) => {
                  if (e.key === "Enter") {
                    handleSearch();
                    setSearchTerm("");
                  }
                }}
                placeholder="Search leads"
                aria-label="Search"
              />
            </div>
          </div>
          <ul class="navbar-nav d-flex align-items-center  justify-content-end">
            <li class="nav-item dropdown pe-3 d-flex align-items-center">
              <a
                href="javascript:;"
                class="nav-link text-body p-0"
                id="dropdownMenuButton"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <i
                  className="pi pi-bell p-overlay-badge"
                  style={{ fontSize: "1.5rem" }}
                >
                  <Badge value={totalCount}></Badge>
                </i>
              </a>
              <ul
                class="dropdown-menu  dropdown-menu-end  px-2 py-3 me-sm-n4"
                aria-labelledby="dropdownMenuButton"
              >
                <div className="notification-body">
                  {assignedNotifications.length > 0 ? (
                    assignedNotifications.map((notification, index) => (
                      <div
                        key={notification.date}
                        className="notification-item"
                      >
                        <div className="d-flex justify-content-between align-items-center">
                          <span>{notification.message}</span>
                          <br />
                          <span className="text-muted">
                            {formatTimeElapsed(notification.date)}
                          </span>
                        </div>
                        {index < assignedNotifications.length - 1 && <hr />}
                      </div>
                    ))
                  ) : (
                    <b>No new Notifications</b>
                  )}
                </div>
              </ul>
            </li>

            <li class="nav-item dropdown pe-3 d-flex align-items-center">
              <button
                className="nav-link "
                id="navbarDropdown"
                data-bs-toggle="dropdown"
                aria-expanded="false"
                style={{
                  background: "none",
                  border: "none",
                  padding: 0,
                  font: "inherit",
                  color: "inherit",
                  cursor: "pointer",
                }}
              >
                <div className="profile-pic">
                  {(() => {
                    // console.log("userRole:", userRole);
                    // console.log(
                    //   "Expected roles:",
                    //   Role.SUPERADMIN.roleId,
                    //   Role.ADMIN.roleId,
                    //   Role.MANAGER.roleId
                    // );
                    if (
                      userRole == Role.SUPERADMIN.roleId ||
                      userRole == Role.ADMIN.roleId ||
                      userRole == Role.MANAGER.roleId
                    ) {
                      return (
                        <img
                          src={profilePic}
                          alt="DreamTown Logo"
                          style={{
                            width: "35px",
                            height: "35px",
                            objectFit: "cover",
                            borderRadius: "50%",
                          }}
                        />
                      );
                    } else {
                      return (
                        <img
                          src={`data:image/jpeg;base64,${userImage}`}
                          alt="User's Profile"
                          style={{
                            width: "35px",
                            height: "35px",
                            objectFit: "cover",
                            borderRadius: "50%",
                          }}
                        />
                      );
                    }
                  })()}
                </div>
              </button>
              <ul
                class="dropdown-menu  dropdown-menu-end  px-2 py-3 me-sm-n4"
                aria-labelledby="dropdownMenuButton"
              >
                <li>
                  <button
                    className="dropdown-item"
                    onClick={handleAccountClick}
                    style={{
                      background: "none",
                      border: "none",
                      padding: 5,
                      margin: 7,
                      font: "inherit",
                      color: "inherit",
                      cursor: "pointer",
                    }}
                  >
                    <FaUser /> Your Profile
                  </button>
                </li>
                <li>
                  <hr className="dropdown-divider" />
                </li>
                <li>
                  {isLoggedIn ? (
                    <button
                      className="dropdown-item"
                      onClick={handleLogout}
                      style={{
                        background: "none",
                        border: "none",
                        padding: 5,
                        margin: 7,
                        font: "inherit",
                        color: "inherit",
                        cursor: "pointer",
                      }}
                    >
                      <FaSignOutAlt /> LogOut
                    </button>
                  ) : (
                    <button
                      className="dropdown-item"
                      onClick={() => navigate("/login")}
                      style={{
                        background: "none",
                        border: "none",
                        padding: 5,
                        margin: 7,
                        font: "inherit",
                        color: "inherit",
                        cursor: "pointer",
                      }}
                    >
                      <FaUserAlt /> Login
                    </button>
                  )}
                </li>
              </ul>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
}

export default Navbar;
